import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function FAQ() {
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const style = {
    section: {
      display: 'block',
      unicodeBidi: 'isolate',
      padding: '100px 0',
    },

    Container: {
      width: '100%',
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 24px',
      maxWdth: '800px',
      margin: '0 auto',
    },

    FaqHeader: {
      textAlign: 'center',
      marginBottom: '64px',
      maxWidth: '600px',
      marginLeft: 'auto',
      marginRight: 'auto',
    },

    FaqH2: {
      fontFamily: ' var(--font- headings)',
      lineHeight: '1.2',
      fontWeight: '700',
    },

    FaqP: {
      display: 'block',
      marginBlockStart: '1em',
      marginBlockEnd: '1em',
      marginInlineStart: '0px',
      marginInlineEnd: '0px',
      unicodeBidi: 'isolate',
      color: '#ffffffaa'
    },

    faqItem: {
      backgroundColor: 'transparent !important',
      borderTop: '0px solid var(--border)',
      borderLeft: '0px solid var(--border)',
      borderRight: '0px solid var(--border)',
      marginBottom: '16px',
    },

    faqIcon: {
      color: '#A5E13B',
      transition: 'transform 0.3s ease',
    },

    faqQuestion: {
      width: '100%',
      padding: '14px 0',
      background: 'transparent !important', // Garante que o fundo não mude
      border: 'none',
      // Isso remove aquele "cinza" ou "overlay" do Material UI no hover
      '&:hover': {
        backgroundColor: 'transparent !important',
      },
      // Alvo específico: o texto dentro do Summary
      '& .MuiTypography-root': {
        color: '#fff', // Cor padrão
        transition: 'color 0.3s ease',
      },
      // Quando o mouse passa no botão, APENAS o texto fica verde
      '&:hover .MuiTypography-root': {
        color: '#A5E13B',
      },
      '& .MuiAccordionSummary-expandIconWrapper': {
        color: '#A5E13B',
      }
    },

    faqAnswer: {
      padding: '0 0 32px 0', // Espaço interno da resposta
      color: '#9FA4B4', // Cinza do texto
      fontSize: '1rem',
      lineHeight: '1.6',
    },

    faqAnswerInner: {
      paddingBottom: '24px',
    }
  }

  return (
    <Container id="faq" sx={style.section}>
      <Box sx={style.Container}>
        <Box sx={style.FaqHeader}>
          <Typography
            component="h2"
            variant="h2"
            sx={style.FaqH2}>
            Perguntas frequentes
          </Typography>

          <Typography
            component="p"
            variant="p"
            sx={style.FaqP}>
            Tudo o que você precisa saber sobre a plataforma Phorm
          </Typography>
        </Box>

        <Box>
          <Accordion
            sx={style.faqItem}
            expanded={expanded === 'panel1'}
            onChange={handleChange('panel1')} >
            <AccordionSummary sx={style.faqQuestion} expandIcon={<ExpandMoreIcon />} id="panel1d-header">
              <Typography sx={{
                fontSize: '1.1rem',
                fontFamily: 'var(--font-headings)',
                fontWeight: '500'
              }}>
                O que é a Phorm Pass?
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={style.faqAnswer}>
              A Phorm Pass é um agregador de espaços esportivos. Com uma única assinatura, você tem acesso a centenas de academias, estúdios de yoga, CrossFit e profissionais da área da saúde sem precisar ficar preso aos contratos de longo prazo em um único local.
            </AccordionDetails>
          </Accordion>

          <Accordion
            sx={style.faqItem}
            expanded={expanded === 'panel2'}
            onChange={handleChange('panel2')} >
            <AccordionSummary sx={style.faqQuestion} expandIcon={<ExpandMoreIcon />} id="panel2d-header">
              <Typography sx={{
                fontSize: '1.1rem',
                fontFamily: 'var(--font-headings)',
                fontWeight: '500'
              }}>
                Preciso ser funcionário de uma empresa conveniada?
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={style.faqAnswer}>
              Não! Diferente de outros concorrentes, a Phorm possui planos individuais (B2C) e
              corporativos (B2B). Qualquer pessoa pode baixar o app, assinar nosso plano e começar a
              treinar hoje mesmo.
            </AccordionDetails>
          </Accordion>

          <Accordion
            sx={style.faqItem}
            expanded={expanded === 'panel3'}
            onChange={handleChange('panel3')} >
            <AccordionSummary sx={style.faqQuestion} expandIcon={<ExpandMoreIcon />} id="panel3d-header">
              <Typography sx={{
                fontSize: '1.1rem',
                fontFamily: 'var(--font-headings)',
                fontWeight: '500'
              }}>
                Existe algum custo adicional (taxa de matrícula)?
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={style.faqAnswer}>
              De forma alguma. Ao assinar a Phorm, não cobramos taxa de matrícula nem taxa de manutenção
              anual. Você paga apenas o valor da mensalidade e pode cancelar a qualquer momento sem
              burocracia.
            </AccordionDetails>
          </Accordion>

          <Accordion
            sx={style.faqItem}
            expanded={expanded === 'panel4'}
            onChange={handleChange('panel4')} >
            <AccordionSummary sx={style.faqQuestion} expandIcon={<ExpandMoreIcon />} id="panel4d-header">
              <Typography sx={{
                fontSize: '1.1rem',
                fontFamily: 'var(--font-headings)',
                fontWeight: '500'
              }}>
                Quais profissionais de saúde estão disponíveis?
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={style.faqAnswer}>
              Além de treinos, o plano inclui acesso (ou descontos severos) a consultas com nutricionistas
              esportivos, fisioterapeutas, psicólogos associados ao Mind Fitness, e acupunturistas da
              nossa rede parceira.
            </AccordionDetails>
          </Accordion>
        </Box>
      </Box>
    </Container>
  );
}
